import { colors } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import useFirstDestinationOfType from "../../../hooks/useFirstDestinationOfType";

const CredentialsModal = ({
  destination,
  open,
  onClose,
  existingConfig = {},
}) => {
  const googlePubSub = useFirstDestinationOfType("google-pubsub") || {
    settings: {},
  };
  const { settings: allSettings } = googlePubSub;

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      existingConfig={existingConfig}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Credentials"
      labelText="Instructions"
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const allSettings = (
    useFirstDestinationOfType("google-pubsub") || { settings: {} }
  ).settings;

  return (
    <ConfigureDestinationsModal
      limitSettings={["eventTopicMappings"]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Mappings"
      labelText="Mappings"
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
};

const RowOrder = [CREDENTIALS, OPTIONS];

export default {
  Rows,
  RowOrder,
  Modals,
};
